import { Button, Checkbox, Dropdown, Tag } from 'antd'
import { t } from 'i18next'
import { useEffect, useMemo, useState } from 'react'
import { TbChevronDown } from 'react-icons/tb'
import { getStatusAttendanceColor } from '../../../helper/getStatusAttendanceColor'

export default function SelectMutiCustom({
  options = [],
  value = [],
  onChange = () => {},
  placeholder = 'Type',
  style = {},
  className = '',
  isStatus = false,
  hasSelectAll = true
}) {
  const [typeSystemOptions, setTypeSystemOptions] = useState([])
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    setTypeSystemOptions(
      options.map((d) => ({
        ...d,
        isSelected: value.includes(d.value)
      }))
    )
  }, [options, value])

  const items = useMemo(
    () =>
      typeSystemOptions.map((d) => ({
        label: (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Checkbox
              className="attendance-select-checkbox"
              checked={d.isSelected}
            />

            {isStatus ? (
              <Tag
                style={{
                  background: getStatusAttendanceColor(d.value).bg,
                  color: getStatusAttendanceColor(d.value).text,
                  border: 0,
                  width: '100%',
                  fontWeight: 500,
                  marginLeft: '8px',
                  marginRight: 0,
                  padding: '4px 8px',
                  fontSize: 12,
                  borderRadius: '6px',
                  textAlign: 'center'
                }}
              >
                {t(d.label)}
              </Tag>
            ) : (
              <label className="ms-2">{t(d.label)}</label>
            )}
          </div>
        ),
        key: d.value
      })),
    [typeSystemOptions, isStatus]
  )

  const handleMenuClick = (e) => {
    e.domEvent.preventDefault()
    e.domEvent.stopPropagation()

    if (e.key === 'ALL') {
      const newTypeSystem = typeSystemOptions.map((d) => ({
        ...d,
        isSelected: !typeSystemOptions.every((d) => d.isSelected)
      }))
      setTypeSystemOptions(newTypeSystem)

      updateFilter(
        newTypeSystem.filter((d) => d.isSelected).map((d) => d.value)
      )
    } else {
      const newTypeSystem = typeSystemOptions.map((d) =>
        d.value + '' === e.key + ''
          ? { ...d, isSelected: !d.isSelected }
          : { ...d }
      )

      setTypeSystemOptions(newTypeSystem)
      updateFilter(
        newTypeSystem.filter((d) => d.isSelected).map((d) => d.value)
      )
    }
  }

  const updateFilter = (_value) => {
    onChange(_value)
  }

  const menuProps = {
    items: [
      ...(hasSelectAll
        ? [
            {
              label: (
                <div>
                  <Checkbox
                    className="attendance-select-checkbox"
                    checked={typeSystemOptions.every((d) => d.isSelected)}
                  />
                  <label className="ms-2">{t('ALL')}</label>
                </div>
              ),
              key: 'ALL'
            }
          ]
        : []),
      ...items
    ],
    onClick: handleMenuClick
  }

  const handleOpenChange = (nextOpen, info) => {
    if (info.source === 'menu') {
      setIsOpen(true)
    } else {
      setIsOpen(nextOpen)
    }
  }

  const countSelected = typeSystemOptions.filter((d) => d.isSelected).length

  return (
    <Dropdown
      autoAdjustOverflow={true}
      menu={menuProps}
      trigger="click"
      style={{
        zIndex: 999
      }}
      onOpenChange={handleOpenChange}
      open={isOpen}
    >
      <Button
        className={`px-2 justify-content-between ${className}`}
        iconPlacement="end"
        style={{
          width: '100%',
          ...style
        }}
      >
        <span style={{ opacity: countSelected > 0 ? 1 : 0.4 }}>
          {countSelected > 0 ? `(${countSelected})` : ''} {placeholder}
        </span>
        <TbChevronDown size={22} style={{ strokeWidth: 1.2 }} />
      </Button>
    </Dropdown>
  )
}
